import React from 'react';
import { 
  TextField, 
  InputAdornment, 
  IconButton,
  Box 
} from '@mui/material';
import { 
  Search as SearchIcon, 
  Clear as ClearIcon 
} from '@mui/icons-material';

/**
 * Search bar component for filtering recipes
 * @param {Object} props
 * @param {string} props.searchQuery - Current search query
 * @param {Function} props.onSearchChange - Function to handle search input changes
 * @param {string} props.placeholder - Placeholder text for the search input
 * @param {Object} props.sx - Additional styling
 */
export default function RecipeSearchBar({ 
  searchQuery, 
  onSearchChange, 
  placeholder = "Search recipes...",
  sx = {}
}) {
  return (
    <Box sx={{ mb: 3, ...sx }}>
      <TextField
        fullWidth
        variant="outlined"
        placeholder={placeholder}
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="action" />
            </InputAdornment>
          ),
          endAdornment: searchQuery && (
            <InputAdornment position="end">
              <IconButton 
                onClick={() => onSearchChange('')} 
                size="small"
                edge="end"
                aria-label="clear search"
              >
                <ClearIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            '&:hover fieldset': {
              borderColor: 'primary.main',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'primary.main',
            },
          },
        }}
      />
    </Box>
  );
}
